import { useUserAuth } from 'common/queries-and-mutations/auth';
import { ErrorFallback } from 'components/ErrorFallback';
import { Loader } from 'components/Loader';
import AdminNavBar from 'components/Navigation/AdminNav/AdminNavBar';
import AdminSideBar from 'components/Navigation/AdminNav/AdminSideBar';
import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

export default function AdminLayout() {
  const { isLoading } = useUserAuth();

  const [show, setShow] = useState<boolean>(false);

  return (
    <main className="w-full">
      {!isLoading ? (
        <ErrorBoundary FallbackComponent={ErrorFallback as any}>
          <div className="flex flex-col bg-[#F4F5F6] sm:w-min md:w-full">
            <div className="fixed bg-[#F4F5F6] sm:w-min md:flex md:w-full">
              <AdminSideBar show={show} setShow={() => setShow(false)} />
              <div className="w-full flex-1">
                <AdminNavBar
                  onClick={() => setShow(prevState => !prevState)}
                  setShow={() => setShow(false)}
                />
                <div className="mx-auto mt-10 flex h-screen w-[95%] grow flex-col overflow-y-auto p-4 pb-20 sm:mt-14 md:p-8 xl:w-[99%]">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </ErrorBoundary>
      ) : (
        <div className="flex min-h-screen items-center justify-center">
          <Loader height={100} width={100} color="#FF7A00" />
        </div>
      )}
    </main>
  );
}
